import { render, staticRenderFns } from "./Transactionhistory.vue?vue&type=template&id=35410285&scoped=true&"
import script from "./Transactionhistory.vue?vue&type=script&lang=js&"
export * from "./Transactionhistory.vue?vue&type=script&lang=js&"
import style0 from "./Transactionhistory.vue?vue&type=style&index=0&id=35410285&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35410285",
  null
  
)

export default component.exports